import { type MutableDatabase } from '@databases/model/database';

export function setFieldVisibleInAllViews(
  database: MutableDatabase,
  fieldId: string,
  databaseFieldIds: readonly string[]
): void {
  database.views.forEach((viewId) => {
    const view = database.viewsById[viewId];

    if (view?.fields) {
      view.setFieldVisibility(fieldId, true, databaseFieldIds, {
        includeNewFieldInValidation: true
      });
    }
  });
}
